import TH_JSFunction from '_tradeholding/js/Classes/JSFunction';

export default TH_JSFunction;